import React, { useEffect } from "react";
import { Edit } from "../customObjects/ShapeUtil";
import {
    copy,
    cut,
    handleBringBack,
    handleBringFwd,
    handleDuplicate,
    handleGroup,
    handleLock,
    handleUngroup,
    handleUnLock,
    isDeviceIsMac,
    isItemLocked,
    paste
} from "../utils/customUtil";
import translator from "./../utils/translation";
import Button from "./Button";
import { ReactComponent as IconLock }  from '../assets/icons/Lock.svg'
import { ReactComponent as IconUnlock } from '../assets/icons/Unlock.svg'
import { ReactComponent as IconRemove } from '../assets/icons/bin.svg'
import { ReactComponent as IconBringBack } from '../assets/icons/bring-back.svg'
import { ReactComponent as IconBringFwd } from '../assets/icons/bring-forward.svg'
import { ReactComponent as IconDuplicate } from '../assets/icons/duplicate.svg'
import { ReactComponent as IconFlipH } from '../assets/icons/flip-h.svg'
import { ReactComponent as IconFlipV } from '../assets/icons/flip-v.svg'
import { ReactComponent as IconGroup } from '../assets/icons/Group.svg'
import { ReactComponent as IconUngroup } from '../assets/icons/Ungroup.svg'


const SelectionObjectSettings = ({
                                     canvas,
                                     activeSelection,
                                     isMarkToolRelease
                                 }) => {
    //
    // let selectedObject = "";
    // let selectedCorner = "";

    const removeSelectedLogFlag = async () => {
        if (canvas !== undefined) {
            await canvas._objects.forEach((item) => {
                if (item.locked && item.isLockedSelected) {
                    if (
                        item.oldStroke !== null &&
                        item.oldStroke !== undefined
                    ) {
                        item.stroke = item.oldStroke;
                        item.strokeWidth = item.oldStrokeWidth;
                    } else {
                        item.strokeWidth = 0;
                        item.stroke = "";
                    }
                    item.isLockedSelected = false;
                }
            });
            await canvas.requestRenderAll();
            canvas.calcOffset();
        }
    };

    useEffect(() => {
        if (
            canvas !== undefined &&
            (canvas?.getActiveObject()?.get("type") === "polygon" ||
                canvas?.getActiveObject()?.get("type") === "polyline")
        ) {
            canvas.getActiveObject().hasControls = true;
            canvas.getActiveObject().edit = false;
            Edit(canvas);
        }
    }, [canvas?.getActiveObject()]);

    useEffect(() => {
        if (canvas !== undefined) {
            canvas?.on("mouse:down", ({ target }) => {
                // if (target && canvas.getActiveObject()?.get("type") === "polyline") {
                //     selectedObject = "polyline";
                //     if (target.__corner) {
                //         selectedCorner = target.__corner;
                //     }
                // }

                removeSelectedLogFlag().then((r) => {
                    if (target && target.locked) {
                        target.isLockedSelected = true;
                        target.stroke = "#C00000";
                        target.strokeWidth = 2;
                    }
                });
            });
        }
    }, [canvas]);

    //
    // canvas?.on("mouse:move", (o) => {
    //     if (selectedObject === "polyline" && selectedCorner !== "") {
    //         let poly = canvas.getActiveObject();
    //         const dims = poly._calcDimensions();
    //         let pointerPoints = canvas.getPointer(o.e);
    //         let positionNumber = selectedCorner.charAt(1);
    //         poly.points[positionNumber] = { x: pointerPoints.x, y: pointerPoints.y };
    //         poly.width = dims.width;
    //         poly.height = dims.height;
    //         poly.left = dims.left;
    //         poly.top = dims.top;
    //         poly.pathOffset = {
    //             x: dims.width / 2 + dims.left,
    //             y: dims.height / 2 + dims.top
    //         };
    //         poly.objectCaching = false;
    //         canvas.requestRenderAll();
    //         canvas.calcOffset();
    //     }
    // });
    //
    //
    // canvas?.on("mouse:up", (o) => {
    //     selectedObject = "";
    //     selectedCorner = "";
    //     canvas.requestRenderAll();
    //     canvas.calcOffset();
    // });

    useEffect(() => {
        if (activeSelection) {
            removeSelectedLogFlag();
        }
    }, [activeSelection]);

    useEffect(() => {
        document.addEventListener("keydown", handleObjectCopy);

        return () => {
            document.removeEventListener("keydown", handleObjectCopy);
        };
    }, [canvas, isMarkToolRelease]);

    const handleObjectCopy = (e) => {
        // console.log('Past-e:', e)
        const key = e.which || e.keyCode;
        if (key === 67 && (e.ctrlKey || e.metaKey)) {
            //  console.log('Copy:', key)
            copy(canvas, isMarkToolRelease);
        } else if (key === 88 && (e.ctrlKey || e.metaKey)) {
            cut(canvas);
        } else if (key === 86 && (e.ctrlKey || e.metaKey)) {
            console.log("Paste:", key);
            paste(canvas, isMarkToolRelease);
        }
    };

    const handleFlipH = () => {
        if (isItemLocked(canvas)) return;
        if (!activeSelection) return;
        activeSelection.forEach((item) => item.set("flipX", !item.flipX));
        canvas.requestRenderAll();
        canvas.calcOffset();
        canvas.fire("object:modified");
    };

    const handleFlipV = () => {
        if (isItemLocked(canvas)) return;
        if (!activeSelection) return;
        activeSelection.forEach((item) => item.set("flipY", !item.flipY));
        canvas.requestRenderAll();
        canvas.calcOffset();
        canvas.fire("object:modified");
    };

    const handleDel = () => {
        if (isItemLocked(canvas)) return;
        if (!activeSelection) return;
        canvas?.getActiveObjects().forEach((obj) => {
            canvas.remove(obj);
        });
        canvas?.discardActiveObject().requestRenderAll();
        canvas.calcOffset();
        canvas.fire("object:modified");
    };

    return (
        <div className="setting flex small-buttons">
            <Button
                name="flip-h"
                title={translator("Flip horizontally")}
                handleClick={() => handleFlipH()}
            >
                <IconFlipH />
            </Button>
            <Button
                name="flip-v"
                title={translator("Flip vertically")}
                handleClick={() => handleFlipV()}
            >
                <IconFlipV />
            </Button>
            <Button
                name="bring-fwd"
                title="Forward"
                shortCut={isDeviceIsMac() ? "⌘ + ]" : "Ctrl + ]"}
                handleClick={() => handleBringFwd(activeSelection, canvas)}
            >
                <IconBringFwd />
            </Button>
            <Button
                name="bring-back"
                title="Backward"
                shortCut={isDeviceIsMac() ? "⌘ + [" : "Ctrl + ["}
                handleClick={() => handleBringBack(activeSelection, canvas)}
            >
                <IconBringBack />
            </Button>
            <Button
                name="duplicate"
                title={translator("Duplicate")}
                shortCut={isDeviceIsMac() ? "⌘ + D" : "Ctrl + D"}
                handleClick={() => handleDuplicate(activeSelection, canvas)}
            >
                <IconDuplicate />
            </Button>
            <Button
                name="remove"
                title={translator("Remove")}
                shortCut="Delete"
                handleClick={() => handleDel()}
            >
                <IconRemove />
            </Button>
            <Button
                name="group"
                title="Group"
                handleClick={() => handleGroup(activeSelection, canvas)}
            >
                <IconGroup />
            </Button>
            <Button
                name="ungroup"
                title="Ungroup"
                handleClick={() => handleUngroup(activeSelection, canvas)}
            >
                <IconUngroup />
            </Button>
            <Button
                name="lock"
                title="Lock"
                handleClick={() => handleLock(activeSelection, canvas)}
            >
                <IconLock />
            </Button>
            <Button
                name="unlock"
                title="Unlock"
                handleClick={() => handleUnLock(activeSelection, canvas)}
            >
                <IconUnlock />
            </Button>
        </div>
    );
};

export default SelectionObjectSettings;
